export const getTeamMembers = state => state.teamMembers.users;
export const getIsLoadingTeamMembers = state => state.teamMembers.isLoading;
export const getTeamMembersError = state => state.teamMembers.errorMessage;
export const getUserUpdated = state => state.teamMembers.updateSuccessful;
export const getUserDeleted = state => state.teamMembers.deleteSuccessful;
